import { daekyoSpaceAPI } from '@/api';
import CommonSpaceListContainer from '@/components/common/CommonSpaceListContainer';
import DaekyoHeader from './DaekyoHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface DaekyoSpaceDataType {
  id: number;
  publish: boolean;
  title: string;
  description: string;
  category: number;
  img: string;
  detail_info: any;
  link_detail: string;
  link_reserve: string;
  link_viewer: string;
  latlng: string;
  createdAt: string;
  updatedAt: string;
}

const columnHelper = createColumnHelper<DaekyoSpaceDataType>();

const categoryMap: { [key: string]: string } = {
  '1': '객실',
  '2': '다이닝',
  '3': '웨딩&연회',
  '4': '휴식&액티비티',
};

const getColumns = (): ColumnDef<DaekyoSpaceDataType, any>[] => {
  const baseColumns = [
    columnHelper.accessor('id', {
      header: 'ID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('title', {
      header: '이름',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('description', {
      header: '설명',
      cell: (info) => {
        const text = info.getValue() || '';
        return text.length > 10 ? `${text.slice(0, 10)}...` : text;
      },
    }),
    columnHelper.accessor('category', {
      header: '카테고리',
      cell: (info) =>
        categoryMap[info.getValue().toString()] || info.getValue(),
    }),
    columnHelper.accessor('publish', {
      header: '앱 사용 여부',
      cell: (info) => (info.getValue() ? '사용' : '미사용'),
    }),
    columnHelper.accessor('updatedAt', {
      header: '수정일',
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
  ];

  return baseColumns.filter(Boolean) as ColumnDef<DaekyoSpaceDataType, any>[];
};

const DaekyoContainer = () => {
  return (
    <CommonSpaceListContainer<DaekyoSpaceDataType>
      HeaderComponent={DaekyoHeader}
      queryKey="getSpacesDaekyo"
      queryFn={() =>
        daekyoSpaceAPI.getSpaces({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
      baseRoute="/daekyo/space"
      buttonColor="resom"
      showCreateButton={false}
    />
  );
};

export default DaekyoContainer;
